module.exports = __webpack_public_path__ + "img/firstbreadtest_thumb.86933b07.jpg";